import React from 'react'

import SidebarContext from 'Contexts/SidebarContext'

const useSidebarState = () => React.useContext(SidebarContext)

export default useSidebarState
